import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";

@Component({
  selector: "app-hcc-summary-by-aid",
  templateUrl: "./hcc-summary-by-aid.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HccSummaryByAidComponent {
    filters: string[];
    dashboardType = LookerRiskDashboardType.HCC_SUMMARY_BY_AID;

    constructor() {
        this.filters = ["Projects", "Address", "Hcc", "Products", "LOB", "RetrievalOwner", "ChaseTags"];
    }

}
